export const ROUTE_SUFFIXES: Record<string, string> = {
  assigned: 'assigned',
  pullsAssignedToMe: 'assigned',
  mentioned: 'mentioned',
  createdByMe: 'created',
  recentActivity: 'recent',
}
